import React, { useState, useEffect } from "react"
import {
	Box,
	Tooltip,
	OutlinedInput,
	InputLabel,
	MenuItem,
	FormControl,
	ListItemText,
	Select,
	Checkbox,
	makeStyles,
	TextField,
	useTheme,
} from "@material-ui/core"
import { useSelector } from "react-redux"
import { KeyboardArrowDown } from "@material-ui/icons"
import { Skeleton } from "@material-ui/lab"

//basic settings
const MenuProps = {
	PaperProps: {
		style: {
			maxWidth: 216,
			maxHeight: 287,
			textTransform: "capitalize",
		},
	},
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	variant: "menu",
	getContentAnchorEl: null,
}

const useStyles = makeStyles((theme) => ({
	boxWrapper: {
		maxWidth: 141,
		minWidth: 141,
		minHeight: 48,
		maxHeight: 48,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "transparent",
		},
		"& .MuiSelect-icon.Mui-disabled": {
			opacity: "0.5",
		},
	},
}))

const FileTypes = ({ handleFileTypeChange, resetFilter = false, selected = [], setSelected = () => {}, disableFilters }) => {
	const classes = useStyles()
	const theme = useTheme()

	const isSourcesLoading = useSelector((state) => state.info?.isSourcesLoading)
	const sources = useSelector((state) => state.info?.sourcesList || [])

	const isAllSelected = sources.length > 0 && selected.length === sources.length

	const handleChange = (event) => {
		const value = event.target.value
		if (value[value.length - 1] === "all") {
			setSelected(selected.length === sources.length ? [] : sources)
			handleFileTypeChange(selected.length === sources.length ? [] : sources)
			return
		}
		setSelected(value)
		handleFileTypeChange(value)
	}

	return (
		<Box className={classes.boxWrapper} m={1}>
			<FormControl fullWidth size="small">
				{/* <InputLabel style={{ fontWeight: 400 }} id="demo-simple-select-label">
					File Types
				</InputLabel> */}
				<Tooltip placement="top" arrow title={selected.join(", ")}>
					{/* <Select
						labelId="source-multiple-checkbox-label"
						id="source-multiple-checkbox"
						multiple
						value={selected}
						onChange={handleChange}
						input={<OutlinedInput label="File Types" />}
						renderValue={(selected) => selected.join(", ")}
						MenuProps={MenuProps}
						IconComponent={KeyboardArrowDown}
					> */}
					<TextField
						//style={{ width: "100%" }}
						//style={{ color: "#2C3533", fontWeight: "700" }}
						variant="outlined"
						value={selected}
						onChange={handleChange}
						select
						label="File Types"
						id="source-multiple-checkbox-label"
						SelectProps={{
							labelId: "source-multiple-checkbox-label",
							MenuProps: MenuProps,
							IconComponent: KeyboardArrowDown,
							renderValue: (selected) => selected.join(", "),
							multiple: true,
							// value: selected,
							// onChange: handleChange,
							onOpen: () => {
								setTimeout(() => {
									selected?.length > 0 &&
										!isAllSelected &&
										document.querySelector(`[data-name=${selected?.[0]}]`)?.scrollIntoView()
								}, 1)
							},
						}}
						InputLabelProps={{ style: { fontWeight: 400 } }}
						size="small"
						inputProps={{ style: { fontWeight: 400 } }}
						className={classes.select}
						style={{ ...theme.typography.body1, textTransform: "capitalize" }}
						disabled={disableFilters}
					>
						{isSourcesLoading &&
							Array(8)
								.fill()
								.map((data, i) => (
									<MenuItem key={i} value={""}>
										<Skeleton variant="rounded" width={90} height={30} />
									</MenuItem>
								))}
						{!isSourcesLoading && sources.length <= 0 && (
							<ListItemText className="no-data-found-item" primary={"No Data Found"} />
						)}

						{!isSourcesLoading && sources.length > 0 && (
							<MenuItem key={"all"} value={"all"}>
								<Checkbox checked={isAllSelected} />
								<ListItemText primary={"All"} primaryTypographyProps={{ style: { fontWeight: 400 } }} />
							</MenuItem>
						)}
						{!isSourcesLoading &&
							sources.length > 0 &&
							sources.map((name) => (
								<MenuItem key={name} value={name} data-name={name}>
									<Checkbox checked={selected.indexOf(name) > -1} />
									<Tooltip placement="top" arrow title={name}>
										<ListItemText
											primaryTypographyProps={{ style: { fontWeight: 400 } }}
											style={{ textTransform: "capitalize" }}
											primary={name}
										/>
									</Tooltip>
								</MenuItem>
							))}
					</TextField>
					{/* </Select> */}
				</Tooltip>
			</FormControl>
		</Box>
	)
}

export default FileTypes
